import { trackWidgetVersion } from '@migros/msrc-analytics';
import { useEffect } from 'react';
export const useTrackWidgetVersion = widget => useEffect(() => {
  trackWidgetVersion("4.45.6", `msrc-community:${widget}-widget`);
}, []);